// extracted by mini-css-extract-plugin
module.exports = {"dynamo-markdown--no-table-header":"dynamo-markdown_dynamo-markdown--no-table-header__aSfUU"};